import * as React from "react";
import { Fragment } from "react";
import { exists, t } from "i18next";
import { dimensionsKeys, filterActiveDimensionItems } from "../../../../../../utils";
import { FormSelect } from "../../../../../../components/Forms";

export const sortAlphabetically = (a, b) => {
  return a.toLowerCase().localeCompare(b.toLowerCase());
};

const DISPOSAL_METHODS = Object.freeze({
  "ANAEROBIC_DIGESTION": "ANAEROBIC_DIGESTION",
  "COMBUSTION": "COMBUSTION",
  "COMPOSTING": "COMPOSTING",
  "LANDFILL": "LANDFILL",
  "RECYCLED": "RECYCLED"
});

export const generatedWaste = [
  {
    activity: "CONSTRUCTION",
    types: {
      AGGREGATES: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      AVERAGE_CONSTRUCTION: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION],
      ASBESTOS: [DISPOSAL_METHODS.LANDFILL],
      ASPHALT: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      BRICKS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      CONCRETE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      INSULATION: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      METALS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      SOILS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      MINERAL_OIL: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION],
      PLASTERBOARD: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      TYRES: [DISPOSAL_METHODS.RECYCLED],
      WOOD: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL]
    }
  },
  {
    activity: "REFUSE",
    types: {
      HOUSEHOLD_RESIDUAL_WASTE: [DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING,
        DISPOSAL_METHODS.LANDFILL, DISPOSAL_METHODS.ANAEROBIC_DIGESTION],
      ORGANIC_FOOD_AND_DRINK_WASTE: [DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL,
        DISPOSAL_METHODS.ANAEROBIC_DIGESTION],
      ORGANIC_GARDEN_WASTE: [DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL,
        DISPOSAL_METHODS.ANAEROBIC_DIGESTION],
      ORGANIC_MIXED_FOOD_AND_GARDEN_WASTE: [DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL,
        DISPOSAL_METHODS.ANAEROBIC_DIGESTION],
      COMMERCIAL_AND_INDUSTRIAL_WASTE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING,
        DISPOSAL_METHODS.LANDFILL, DISPOSAL_METHODS.ANAEROBIC_DIGESTION]
    }
  },
  {
    activity: "ELECTRICAL_ITEMS",
    types: {
      ELECTRICAL_ITEMS_FRIDGES_AND_FREEZERS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      ELECTRICAL_ITEMS_LARGE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      ELECTRICAL_ITEMS_IT: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      ELECTRICAL_ITEMS_SMALL: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      WEEEFRIDGES_AND_FREEZERS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      WEEELARGE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      WEEEMIXED: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      WEEESMALL: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      BATTERIES: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      BATTERIES_ALKALINE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      BATTERIES_LI_ION: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      BATTERIES_NI_MH: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL]
    }
  },
  {
    activity: "METAL",
    types: {
      ALUMINIUM_CANS_AND_FOIL: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      MIXED_CANS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      SCRAP_METAL: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      STEEL_CANS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL]
    }
  },
  {
    activity: "PLASTIC",
    types: {
      AVERAGE_PLASTICS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      AVERAGE_PLASTIC_FILM: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      AVERAGE_PLASTIC_RIGID: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      HDPE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      LDPEAND_LLDPE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      PET: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      PP: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      PS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      PVC: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL]
    }
  },
  {
    activity: "PAPER",
    types: {
      BOARD: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL],
      MIXED: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL],
      PAPER: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL]
    }
  },
  {
    activity: "OTHER",
    types: {
      BOOKS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL],
      GLASS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      CLOTHING: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      CARDBOARD: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL],
      FOOD_AND_DRINK: [DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL, DISPOSAL_METHODS.ANAEROBIC_DIGESTION]
    }
  }
];

export const businessTravelTransport = [
  {
    mode: "flights",
    subtypes: [
      "domestic",
      "shortHaulAveragePassenger", "shortHaulEconomyClass", "shortHaulBusinessClass",
      "longHaulAveragePassenger", "longHaulEconomyClass", "longHaulPremiumEconomyClass", "longHaulBusinessClass", "longHaulFirstClass",
      "internationalAveragePassenger", "internationalEconomyClass", "internationalPremiumEconomyClass", "internationalBusinessClass", "internationalFirstClass"
    ]
  },
  {
    mode: "ferry",
    subtypes: [
      "footPassenger", "carPassenger", "average"
    ]
  },
  {
    mode: "cars",
    subtypes: [
      "smallCarDiesel", "smallCarPetrol", "smallCarHybrid", "smallCarBatteryElectric", "smallCarPlugInHybrid", "smallCarUnknown",
      "mediumCarDiesel", "mediumCarPetrol", "mediumCarHybrid", "mediumCarCNG", "mediumCarLPG", "mediumCarBatteryElectric", "mediumCarPlugInHybrid", "mediumCarUnknown",
      "largeCarDiesel", "largeCarPetrol", "largeCarHybrid", "largeCarCNG", "largeCarLPG", "largeCarBatteryElectric", "largeCarPlugInHybrid", "largeCarUnknown",
      "averageCarDiesel", "averageCarPetrol", "averageCarHybrid", "averageCarCNG", "averageCarLPG", "averageCarBatteryElectric", "averageCarUnknown"
    ]
  },
  {
    mode: "motorbike",
    subtypes: [
      "smallMotorbike", "mediumMotorbike", "largeMotorbike", "averageMotorbike"
    ]
  },
  {
    mode: "taxis",
    subtypes: [
      "regularTaxi", "blackCab"
    ]
  },
  {
    mode: "bus",
    subtypes: [
      "localBus", "localLondonBus", "averageLocalBus", "coach"
    ]
  },
  {
    mode: "rail",
    subtypes: [
      "nationalRail", "internationalRail", "lightRailAndTram", "londonUnderground"
    ]
  }
];

export const employeeCommutingTransport = [
  {
    mode: "cars",
    subtypes: [
      "smallCarDiesel", "smallCarPetrol", "smallCarHybrid", "smallCarBatteryElectric", "smallCarPlugInHybrid", "smallCarUnknown",
      "mediumCarDiesel", "mediumCarPetrol", "mediumCarHybrid", "mediumCarCNG", "mediumCarLPG", "mediumCarBatteryElectric", "mediumCarPlugInHybrid", "mediumCarUnknown",
      "largeCarDiesel", "largeCarPetrol", "largeCarHybrid", "largeCarCNG", "largeCarLPG", "largeCarBatteryElectric", "largeCarPlugInHybrid", "largeCarUnknown",
      "averageCarDiesel", "averageCarPetrol", "averageCarHybrid", "averageCarCNG", "averageCarLPG", "averageCarBatteryElectric", "averageCarUnknown"
    ]
  },
  {
    mode: "motorbike",
    subtypes: [
      "smallMotorbike", "mediumMotorbike", "largeMotorbike", "averageMotorbike"
    ]
  },
  {
    mode: "taxis",
    subtypes: [
      "regularTaxi", "blackCab"
    ]
  },
  {
    mode: "bus",
    subtypes: [
      "localBus", "localLondonBus", "averageLocalBus", "coach"
    ]
  },
  {
    mode: "rail",
    subtypes: [
      "nationalRail", "internationalRail", "lightRailAndTram", "londonUnderground"
    ]
  },
  {
    mode: "walking",
    subtypes: []
  },
  {
    mode: "cycling",
    subtypes: []
  }
];

export const renderOptions = (optionsArr, optionsTranslationKey, alternativeLabels = []) => {
  return (
    <Fragment>
      {optionsArr.map((option, index) => {
        const label = exists(`${optionsTranslationKey}.${option}`) ?
          t(`${optionsTranslationKey}.${option}`) :
          alternativeLabels.length > 0 && alternativeLabels.length === optionsArr.length ?
            alternativeLabels[index] : option;
        return <option key={option} value={option}>
          {label}
        </option>;
      })}
    </Fragment>
  );
};

export const getProductCodeTitle = (dataArray, index, productCodes) => {
  if (dataArray[index].productCategoryId !== "" && productCodes && Object.keys(productCodes).length > 0) {
    const location = dataArray[index].location;
    const prodCatId = Number(dataArray[index].productCategoryId);
    if (location && !isNaN(prodCatId)) {
      const prodCodeObj = productCodes[location]?.find(code => code.id === prodCatId);
      return typeof prodCodeObj !== "undefined" ? `${prodCodeObj.code} - ${prodCodeObj.name}` : "";
    }
  }
  return "";
};

export const getCurrencyCode = (dataArray, index, locations) => {
  const location = dataArray[index].location;
  const foundLocObj = locations && locations.find(locationObj => locationObj.location === location);
  if (typeof foundLocObj !== "undefined") {
    return foundLocObj.currency;
  }
  return "";
};

// ESG-3894 helpers -----------------------------------------------------------
// Scope 3 rows now carry dimension items (same as Scope 1/2).

export const getActiveDimensionKeys = (organizationStructure) =>
  organizationStructure
    ? dimensionsKeys.filter(dimKey => organizationStructure.dimensions[dimKey])
    : [];

/**
 * Seed fields for the per-row form so new rows inherit the questionnaire's
 * dimension items. Existing rows loaded from the API keep their saved values.
 */
export const buildDimensionFormDefaults = (organizationStructure, questionnaireDimensionItems) => {
  const defaults = {};
  if (!organizationStructure) return defaults;
  getActiveDimensionKeys(organizationStructure).forEach(dimKey => {
    defaults[`${dimKey}Item`] = questionnaireDimensionItems?.[`${dimKey}Item`] ?? "";
  });
  return defaults;
};

/**
 * Wrap the row's `dimensionOneItem`…`dimensionFiveItem` flat fields into the
 * nested `dimensionItems` shape the backend expects. Coerces empty strings to
 * null. Keeps non-dimension fields untouched.
 */
export const withDimensionItems = (row) => {
  const dimensionItems = {};
  dimensionsKeys.forEach(dimKey => {
    const val = row[`${dimKey}Item`];
    dimensionItems[`${dimKey}Item`] = val === "" || val === undefined ? null : val;
    // eslint-disable-next-line no-param-reassign
    delete row[`${dimKey}Item`];
  });
  return { ...row, dimensionItems };
};

/**
 * Flatten each row's `dimensionItems` object back into top-level form fields
 * so the React Hook Form grid can register each dropdown as a discrete field.
 * Used when seeding edit data.
 */
export const flattenDimensionItems = (row) => {
  if (!row || !row.dimensionItems) return row;
  const flat = { ...row, ...row.dimensionItems };
  delete flat.dimensionItems;
  return flat;
};

/**
 * Render one <option> per available item in a dimension dropdown — mirrors the
 * "predefined value" label path used in Scope 1/2 GridItemsSection. Excludes
 * archived items, except `currentValue` so an existing edit-row selection
 * remains visible.
 *
 * When `filteredItems` is provided (from useDimensionFiltering), those are used
 * instead of the full organizationStructure items — enabling parent-based
 * filtering (e.g., showing only divisions under the selected country).
 */
export const renderDimensionOptions = (organizationStructure, dimKey, fieldKeyPrefix, rowIndex, currentValue, filteredItems) => {
  const items = filteredItems || organizationStructure.dimensions[dimKey].items;
  return filterActiveDimensionItems(items, currentValue)
    .map(item => (
      <option key={`${fieldKeyPrefix}-${dimKey}-${rowIndex}-${item.id}`} value={item.id}>
        {item.name}
      </option>
    ));
};

/**
 * Build the dropdown grid-cell inputs for a single row's dimensions. Returns
 * an array of React elements, one per active dimension.
 *
 * When `dimensionItems` (the parent questionnaire's pre-selected items) has a
 * non-null value at a dimension level, that cell renders as a read-only label
 * — matching the Scope 1/2 behaviour in `GridItemsSection.jsx:144-167`. The
 * row's form state is already seeded with the locked value via
 * `buildDimensionFormDefaults`, so the cell just needs to swallow interaction.
 *
 * Optional `getFilteredItems(dimKey, rowIndex)` and `onDimensionChange(rowIndex)`
 * enable parent-based filtering via useDimensionFiltering hook.
 */
export const renderDimensionFormCells = ({
  organizationStructure,
  dimensionItems,
  register,
  fieldArrayName,
  index,
  watchFieldArray,
  getFilteredItems,
  onDimensionChange,
}) => {
  if (!organizationStructure) return [];
  return getActiveDimensionKeys(organizationStructure).map(dimKey => {
    const selectedId = watchFieldArray?.[index]?.[`${dimKey}Item`];
    const filteredItems = getFilteredItems?.(dimKey, index) ?? null;
    const allItems = filteredItems || organizationStructure.dimensions[dimKey].items;
    const selectedName = selectedId
      ? allItems.find(item => item.id.toString() === selectedId?.toString())?.name ?? ""
      : "";
    const isLocked = dimensionItems?.[`${dimKey}Item`] != null;

    if (isLocked) {
      return (
        <FormSelect
          key={`${fieldArrayName}-${index}-${dimKey}Item`}
          {...register(`${fieldArrayName}.${index}.${dimKey}Item`)}
          onMouseDown={(e) => e.preventDefault()}
          borderWidth="0"
          margin="0"
          whiteSpace="nowrap"
          padding="0"
          width="100%"
          style={{ padding: 0 }}
          fontWeight="semibold"
          fontSize="sm"
          color="black"
          icon={<span />}
          title={selectedName}
        >
          {renderDimensionOptions(organizationStructure, dimKey, fieldArrayName, index, selectedId, filteredItems)}
        </FormSelect>
      );
    }

    const dimensionSelector = register(`${fieldArrayName}.${index}.${dimKey}Item`);

    return (
      <FormSelect
        key={`${fieldArrayName}-${index}-${dimKey}Item`}
        {...dimensionSelector}
        onChange={(e) => {
          dimensionSelector.onChange(e);
          onDimensionChange?.(index);
        }}
        fontSize="sm"
        fontWeight="semibold"
        title={selectedName}
      >
        <option value="">{""}</option>
        {renderDimensionOptions(organizationStructure, dimKey, fieldArrayName, index, selectedId, filteredItems)}
      </FormSelect>
    );
  });
};